import {
  SUBMIT_COMPETITOR_PROFILE_V1_REQUEST,
  SUBMIT_COMPETITOR_PROFILE_V1_SUCCESS,
  SUBMIT_COMPETITOR_PROFILE_V1_FAILURE,
} from "../actions/competitorProfileV1Actions";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const competitorProfileV1Reducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_COMPETITOR_PROFILE_V1_REQUEST:
      return {
        ...state,
        loading: true,
        data: null,
        error: null,
      };
    case SUBMIT_COMPETITOR_PROFILE_V1_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case SUBMIT_COMPETITOR_PROFILE_V1_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default competitorProfileV1Reducer;
